import { render } from "./ChatContainer.vue?vue&type=template&id=469075d0&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=469075d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-469075d0"

export default script